import React from "react";
import { graphql, useStaticQuery } from 'gatsby'
import classNames from "classnames";
import withStyles from "@material-ui/core/styles/withStyles";

import { Helmet } from 'react-helmet'

import DefaultLayout from "layouts/default.jsx";

import Avatar from '@material-ui/core/Avatar';
import BackgroundImage from 'gatsby-background-image'
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import PictureHero from "components/PictureHero/PictureHero.jsx";
import HeroCard from "components/HeroCard/HeroCard.jsx";
import Banner from "components/Banner/Banner.jsx";
import Quote from "components/Quote/Quote.jsx";
import JoinModal from "components/JoinModal/JoinModal.jsx";

import landingPageStyle from "assets/jss/material-kit-react/views/landingPage.jsx";

// Sections for this page
import EarlyAdopterCTA from "sections/CTAs/EarlyAdopterCTA.jsx";
import MissingStepCTA from "sections/CTAs/MissingStepCTA.jsx";
import JoinTheMovementCta from "sections/CTAs/JoinTheMovementCTA.jsx";
import OurSharesCTA from "sections/CTAs/OurSharesCTA.jsx";
import YourSharesMyFutureCTA from "sections/CTAs/YourSharesMyFutureCTA.jsx";
import WaitlistCTA from "sections/CTAs/WaitlistCTA.jsx";

import athenaLogo from "assets/img/athena-white.svg";
import womanOnBridge from "assets/img/woman-on-bridge.jpg";

import athenaInvestHero from "data/athena-invest-hero.json";
import athenaConnectHero from "data/athena-connect-hero.json";
import athenaVoteHero from "data/athena-vote-hero.json";
import athenaChangeTheWorldHero from "data/athena-change-the-world-hero.json";

import quotes from "data/quotes.json";

import athena from "data/athena.json";

import Bridge from "components/Background/Bridge.jsx";
import Connect from "components/Background/Connect.jsx";
import RaisedFist from "components/Background/RaisedFist.jsx";
import WindmillMountain from "components/Background/WindmillMountain.jsx";
import WomanOnBridge from "components/Background/WomanOnBridge.jsx";
import athenaImage from "assets/img/athena.png";

const Logo = (props) => {
  const {classes, ...rest } = props;
  return <Avatar src={athenaLogo} className={classNames(classes.athenaLogo, classes.productLogo)} />
};

class AthenaPage extends React.Component {
  render() {
    const { classes, ...rest } = this.props;
    return (
      <DefaultLayout>
        <Helmet>
          <title>athena | we the shareholders</title>
          <meta property="og:title" content="athena | we the shareholders"/>
          <meta name="twitter:title" content="athena | we the shareholders"/>
          <meta name="description" content="Invest. Connect. Vote. Change the world. Athena empowers human investors to invest, grow wealth, and exercise their corporate civic rights and responsibilities as we were always meant to."/>
          <meta property="og:description" content="Invest. Connect. Vote. Change the world. Athena empowers human investors to invest, grow wealth, and exercise their corporate civic rights and responsibilities as we were always meant to."/>
          <meta name="twitter:description" content="Invest. Connect. Vote. Change the world. Athena empowers human investors to invest, grow wealth, and exercise their corporate civic rights and responsibilities as we were always meant to."/>
          <meta property="og:image" content={`https://wetheshareholders.com${athenaImage}`}/>
          <meta name="twitter:image" content={`https://wetheshareholders.com${athenaImage}`}/>
          <meta property="og:image:alt" content="Seen from behind, a young woman crossing over a footbridge into a forest."/>
          <meta name="twitter:image:alt" content="Seen from behind, a young woman crossing over a footbridge into a forest."/>        
        </Helmet>
        <Banner filter={true} BackgroundImage={WomanOnBridge}>
          <div className={classNames(classes.container)}>
            <GridContainer alignContent="space-around" alignItems="center" justify="center">
              <GridItem xs={5} md={4} lg={3}>
              <Logo classes={classes}/>
              </GridItem>
              <GridItem xs={12} lg={5} className={classes.noGutter} >
              <h1 className={classNames(classes.athenaBrandLarge, classes.productBrand)}>athena
              <br/>
              <small className={classNames(classes.athenaSloganLarge, classes.productBrand)}>change corporations. change the world.</small>
              </h1>
              </GridItem>
            </GridContainer>
          </div>
        </Banner>
        <GridContainer alignItems="center">
        </GridContainer>
        <div className={classNames(classes.main)}>
          <div className={classNames(classes.greyBackground)}>
            <div className={classes.waitlistBar}>
              <JoinModal fullWidthButton buttonText="Coming Soon. Join our waitlist."  listIds={[21, 30]}/>
            </div>
            <HeroCard className={classes.productHeaderHeroCard} hero={{
              title: "Invest. Connect. Vote. Change the world.",
              text: "Our Athena app and platform empower human investors to invest, grow wealth, and exercise their corporate civic rights and responsibilities as we were always meant to."}}
              />
            <PictureHero id="invest-section" BackgroundImage={Bridge} imageLeft hero={athenaInvestHero} className={classes.bridgeImage} backgroundImageTop backgroundImageLeft/>
            <GridContainer justify="center">
              <GridItem sx={12} sm={10} md={8}>
                <Quote plain quote={quotes.donaldOne}/>
              </GridItem>
            </GridContainer>
            <PictureHero id="connect-section" BackgroundImage={Connect} imageRight hero={athenaConnectHero}/>
              <GridContainer justify="center">
                <GridItem sx={12} sm={10} md={8}>
                  <Quote plain quote={quotes.bogelTwo}/>
                </GridItem>
              </GridContainer>  
            <PictureHero id="vote-section" BackgroundImage={RaisedFist} imageLeft hero={athenaVoteHero} backgroundImageBottom/>
            <GridContainer justify="center">
              <GridItem sx={12} sm={10} md={8}>
                <Quote plain quote={quotes.greenfield}/>
              </GridItem>
            </GridContainer>
            <PictureHero id="change-the-world-section" BackgroundImage={WindmillMountain} imageRight hero={athenaChangeTheWorldHero} backgroundImageBottom/>
            <WaitlistCTA listIds={[13]}/>
          </div>
        </div>
        <Footer />
      </DefaultLayout>
    );
  }
}

export default withStyles(landingPageStyle)(AthenaPage);
